import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const languages = [
  { code: 'uz', label: "O'zbek", flag: "🇺🇿" },
  { code: 'ru', label: "Русский", flag: "🇷🇺" },
  { code: 'en', label: "English", flag: "🇬🇧" },
];

// Single elegant language toggle button that cycles through languages
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentIndex = languages.findIndex((l) => l.code === i18n.language);
  const currentLang = languages[currentIndex] || languages[0];
  const nextLang = languages[(currentIndex + 1) % languages.length];

  const handleToggle = () => {
    i18n.changeLanguage(nextLang.code);
  };

  return (
    <div className="lang-switcher" aria-label={`Language: ${currentLang.label}`}>
      <button
        className="lang-switcher__button"
        onClick={handleToggle}
        aria-label={`Switch language to ${nextLang.label}`}
      >
        <span className="lang-switcher__flag" aria-hidden="true">{currentLang.flag}</span>
        <span className="lang-switcher__label">{currentLang.label}</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
